// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"0a0c478e","233":"4f596bf8","305":"2cc68b3c","363":"a79a57aa","384":"929b64d4","453":"188b80ca","477":"eb5502c5","671":"9e594467"}[chunkId] + ".chunk.js";
};